import { getCookie } from 'cookies-next';
import { ParsedUrlQuery } from 'querystring';

const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

export function buildAppArgumentUrl(
  asPath: string | undefined,
  query: ParsedUrlQuery | undefined,
): string {
  const path = (asPath || '/').split('?')[0];
  const params = new URLSearchParams();
  params.set('sp_cid', String(getCookie('sp_t') || ''));
  if (query) {
    for (const key of UTM_PARAMS) {
      if (query[key]) params.set(key, String(query[key]));
    }
  }
  return `https://artists.spotify.com${path}?${params.toString()}`;
}
